/** Public operator of STAVBOŠ — only CraftBolt s.r.o., not a VAT payer. */
export const OPERATOR = {
  company: "CraftBolt s.r.o.",
  address: "Nové sady 988/2, 602 00 Brno",
  ic: "29789699",
  icPretty: "297 89 699",
  vatPayer: false,
  registry: "Krajský soud v Brně, oddíl C, vložka 152740",
  email: "stavbos@post.cz",
  site: "www.stavbos.cz",
  bankName: "Raiffeisenbank a.s.",
  bankAccount: "942370005/5500",
  iban: "CZ62 5500 0000 0009 4237 0005",
};

export function operatorFooterLine(year = new Date().getFullYear()) {
  return `© ${year} STAVBOŠ · ${OPERATOR.company} · IČO ${OPERATOR.icPretty} · ${OPERATOR.address} · neplátce DPH`;
}

export function operatorBankLine() {
  return `Bankovní účet: ${OPERATOR.bankAccount} (${OPERATOR.bankName}), IBAN ${OPERATOR.iban}`;
}
